export default "__VITE_ASSET__BEDvIZNW__"